import { type PictogramIconProps } from './types';

// finance_02
export const BarChart = ({ color }: PictogramIconProps) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 113 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.1183 37.0996C43.1183 36.2712 43.7899 35.5996 44.6183 35.5996H68.008C68.8364 35.5996 69.508 36.2712 69.508 37.0996V98.9619C69.508 99.7903 68.8364 100.462 68.008 100.462H44.6183C43.7899 100.462 43.1183 99.7903 43.1183 98.9619V37.0996ZM46.1183 38.5996V97.4619H66.508V38.5996H46.1183Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2988 52.6367C13.2988 51.8083 13.9704 51.1367 14.7988 51.1367H38.1787C39.0071 51.1367 39.6787 51.8083 39.6787 52.6367V98.9717C39.6787 99.8001 39.0071 100.472 38.1787 100.472H14.7988C13.9704 100.472 13.2988 99.8001 13.2988 98.9717V52.6367ZM16.2988 54.1367V97.4717H36.6787V54.1367H16.2988Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.6514 13.0283C72.6514 12.1999 73.3229 11.5283 74.1514 11.5283H97.5411C98.3695 11.5283 99.0411 12.1999 99.0411 13.0283V98.9618C99.0411 99.7903 98.3695 100.462 97.5411 100.462H74.1514C73.3229 100.462 72.6514 99.7903 72.6514 98.9618V13.0283ZM75.6514 14.5283V97.4618H96.0411V14.5283H75.6514Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};
